import ReleaseAlert from './ReleaseAlert';

export default ReleaseAlert;
